import classnames from 'classnames';
import React, { ChangeEvent, useState } from 'react';

import { capitalize } from '@eika-infrastruktur/format';
import { RowButton, StandardButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import { EikaModal } from '../../../../components/EikaModal';
import NoteFieldLayout from '../../../../components/NoteField/NoteFieldLayout';
import { StickyFooterRow } from '../../../../components/shared/StickyFooter';
import useTranslation from '../../../../hooks/useTranslation';
import formatSalaryDates from '../../../../utils/mapper/formatSalaryDates';

import './SalaryDateField.scss';

interface Props {
    paydays: Record<number, boolean>;
    setPaydays: (map: Record<number, boolean>) => void;
    error?: string;
}

const SalaryDateField: React.FC<Props> = ({ paydays, setPaydays, error }) => {
    const translated = useTranslation();
    const [showModal, setShowModal] = useState(false);

    const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        setPaydays({
            ...paydays,
            [Number(e.target.value)]: e.target.checked,
        });
    };
    return (
        <>
            <RowButton onClick={() => setShowModal(true)} className="salary-date-field">
                <NoteFieldLayout
                    placeholder={translated.salaryInfo.edit.paydays.placeholder}
                    label={translated.salaryInfo.edit.paydays.label}
                    note={formatSalaryDates(paydays, translated)}
                    icon={IconTypes.LITEN_PIL_HOEYRE}
                    error={error}
                />
            </RowButton>
            <EikaModal id="salary-date-field-modal" open={showModal} setOpen={setShowModal}>
                <h2>{translated.salaryInfo.edit.paydays.title}</h2>
                <p>{translated.salaryInfo.edit.paydays.subtitle}</p>
                <div className="salary-date-field__calendar">
                    {Array.from(Array(31)).map((_, index) => (
                        <div
                            // eslint-disable-next-line react/no-array-index-key
                            key={index}
                            className={classnames('salary-date-field__date', {
                                checked: paydays?.[index + 1],
                            })}
                        >
                            <label htmlFor={`salary-date-${index}`}>
                                <span>{translated.salaryInfo.edit.paydays.the}</span>
                                {index + 1}
                                <span>.</span>
                            </label>
                            <input
                                type="checkbox"
                                id={`salary-date-${index}`}
                                value={index + 1}
                                checked={paydays?.[index + 1] ?? false}
                                onChange={onInputChange}
                            />
                        </div>
                    ))}
                    <div
                        className={classnames('salary-date-field__date salary-date-field__last-day', {
                            checked: paydays?.[32],
                        })}
                    >
                        <label htmlFor="salary-date-last-day">
                            {capitalize(translated.salaryInfo.edit.paydays.lastDay)}
                        </label>
                        <input
                            type="checkbox"
                            id="salary-date-last-day"
                            value="32"
                            checked={paydays?.[32] ?? false}
                            onChange={onInputChange}
                        />
                    </div>
                </div>
                <StickyFooterRow>
                    <StandardButton onClick={() => setShowModal(false)}>{translated.continue}</StandardButton>
                </StickyFooterRow>
            </EikaModal>
        </>
    );
};

export default SalaryDateField;
